<script lang="ts">
    import { location } from "./lib/store"
    import SsrSkip from "./lib/components/SsrSkip.svelte"
    import Header from "./lib/components/Header.svelte"
    import Footer from "./lib/components/Footer.svelte"
    import Content from "./lib/components/Content.svelte"
    import ProductDetails from "./routes/ProductDetails.svelte"
    import Preview from "./routes/Preview.svelte"
    import Cart from "./routes/Cart.svelte"

    export let url = ""

    if (url) {
        // ssr
        let l = url.split("?")
        $location = {
            path: l[0],
            search: l.length > 1 ? l[1] : "",
            hash: "",
            push: false,
            pop: false,
        }
    }
</script>

<Header />
<main>
    {#if $location?.path?.startsWith("/preview")}
        <Preview />
    {:else if $location?.path?.startsWith("/cart")}
        <Cart />
    {:else if $location?.path?.startsWith("/products/")}
        <ProductDetails location="{$location}" />
    {:else}
        <Content location="{$location}" />
    {/if}
</main>
<Footer />

<SsrSkip />

<style lang="less" global>
    @import "./css/style.less";
</style>
